export class VerifyOtp {
  MobileNo: any;
  OTP: any;
  EmailId:any;
}